import React from 'react'
import ReactDOM from 'react-dom'

import mobileMenu from './modules/mobile-menu.js'
import stickyMenu from './modules/menu-sticky.js'

import accordionMenu from './modules/accordion-menu.js'

import machineTyping from './modules/machine-typing.js'

import counter from './modules/counter.js'
import beforeAfter from './modules/before-after.js'
import tabsSteps from './modules/tab-steps.js'

import aos from './modules/aos.js'
